import { Nullable } from "../../base-types";
import CultureInfo from "../../culture-info";
import { IProperty } from "./property";
import { IRelatedPath } from "./related-path";
import { IRelation } from "./relation";
import { IRendition } from "./rendition";

export class EntityConstructionArgs {
    definitionName: string;
    id?: Nullable<number> = null;
    identifier: Nullable<string> = null;
    properties: Array<IProperty> = [];
    relations: Array<IRelation> = [];
    cultures: Array<CultureInfo> = [];
    renditions: Array<IRendition> = [];
    relatedPaths: Array<IRelatedPath> = [];

    constructor(definitionName: string, init?: Omit<Partial<EntityConstructionArgs>, "definitionName">) {
        this.definitionName = definitionName;

        Object.assign(this, init);
    }
}
